import React, { Component } from 'react'
import { connect } from 'react-redux'
import settings from '../../../settings'
import axios from 'axios'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import dayjs from 'dayjs'
import LockWatch from './LockWatch'
import BrowseReport from './BrowseReport'

class QueryWatches extends Component {
    constructor(p) {
        super(p)

        this.state = { downloadedReports: [], reports: [], openedReport: {} }
    }

    componentDidMount() {
        this.getWatches()
        this.getReports()
    }

    getWatches = () => {
        axios.get(`${window.MYQLOCX_API}/subject/admin/bi/settings/querywatch`).then(t => {
            this.setState({ watches: t.data })
        }).catch((e) => {
            console.log(e)
        })
    }

    getReports = () => {
        axios.get(`${window.MYQLOCX_API}/subject/admin/bi/querywatchreports`).then(t => {
            console.log(t.data)
            this.setState({ reports: t.data.reverse() })
        }).catch((e) => {
            console.log(e)
        })
    }

    getReport = (dateUnix) => {
        var state = { ...this.state }
        for (var d of this.state.downloadedReports) {
            if (d.dateUnix === dateUnix) {
                state.openedReport = d
            }
        }

        if (!Object.keys(state.openedReport).length) {
            console.log("ladda ned!")
            axios.get(`${window.MYQLOCX_API}/subject/admin/bi/querywatchreports/${dateUnix}`).then(t => {
                var report = t.data[0]
                report.data = JSON.parse(report.data).reverse()

                var state = { ...this.state }
                state.openedReport = report
                state.downloadedReports = this.state.downloadedReports.concat(report)
                state.reports = state.reports.map(r => {
                    if (r.reportName === report.reportName) {
                        report.isViewed = true
                        r = report
                    }

                    return r
                })

                this.setState(state)
            }).catch((e) => {
                console.log(e)
            })
        } else {
            console.log("redan nedladdad")
            this.setState(state)
        }
    }

    renderBadge = (isViewed) => {
        if (isViewed) {
            return <Glyphicon glyph="glyphicon glyphicon-ok" style={{ color: 'green' }}></Glyphicon>
        }

        return <Glyphicon glyph="glyphicon glyphicon-eye-close" style={{ color: 'red' }}></Glyphicon>
    }

    render() {
        const { locks = [], keyedCarriers = {} } = this.props

        const keyedLocks = locks.reduce((acc, val) => {
            acc[val._id] = val
            return acc
        }, {})

        return (
            <Grid fluid style={{ backgroundColor: 'white' }}>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <div style={{ width: '20%', float: 'left', borderRight: '1px solid lightgrey', height: '100%', padding: 10 }}>
                            <div style={{ textAlign: 'center' }}>
                                Rapporter ({this.state.reports.length})<br />
                                <button onClick={() => this.getReports()}>Uppdatera</button>
                            </div>

                            <hr />

                            <div style={{ height: '100%', overflowY: 'scroll' }}>
                                {this.state.reports ? this.state.reports.map((report, i) => {
                                    const lock = keyedLocks[report.lockId]
                                    return (
                                        <div onClick={() => this.getReport(report.dateUnix)} className="hoverEffect" key={i} style={{ border: '1px solid #006e78', borderRadius: 5, width: '90%', marginLeft: '5%', padding: 5, marginBottom: 5 }}>
                                            {this.state.openedReport.reportName === report.reportName ?
                                                <BrowseReport keyedCarriers={keyedCarriers} report={this.state.openedReport} closeModal={() => this.setState({ openedReport: {} }, () => console.log(this.state.openedReport))} modalIsOpen={this.state.openedReport.reportName === report.reportName} />
                                                :
                                                null
                                            }

                                            <p><b>{lock ? `${lock.custom_name}, ${lock.address.street}` : ''}</b> {this.renderBadge(report.dataRowsQty > 0 ? report.isViewed : true)}</p>
                                            <p>Antal träffar: {report.dataRowsQty}</p>
                                            <p>{dayjs(report.created).format('HH:mm DD/MM')}</p>
                                        </div>
                                    )
                                }) : <p>Laddar....</p>}
                                <br /><br /><br /><br />
                            </div>
                        </div>

                        <div style={{ width: '100%', height: '100%', padding: 10 }}>
                            <div style={{ textAlign: 'center' }}>
                                Enheter
                    </div>

                            <hr />

                            <Grid fluid style={{ overflow: 'scroll', height: '100%' }}>
                                {this.state.watches ? locks.map((lock, i) => {
                                    return (
                                        <LockWatch watch={this.state.watches.find(w => w.lockId === lock._id)} lock={lock} key={i} />
                                    )
                                }) : <p>Laddar....</p>}
                                <br /><br /><br /><br />
                            </Grid>
                        </div>
                    </Col>
                </Row>
            </Grid>
        )
    }

}


const mapProps = state => {
    return {
        admin: state.collectionData.admin,
        locks: state.collectionData.locks
    }
}

const mapDispatch = dispatch => {
    return {
    }
}

export default connect(mapProps, mapDispatch)(QueryWatches)
